import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, InputGroup } from 'react-bootstrap';
import { ViewTemplates, getCompany } from '../../../helpers/';
import axios from 'axios';
// import './AddNewTemplate.css';

import EmojiPicker from 'emoji-picker-react';

interface ViewTemplateProps {
    templateId?: any;
    newTemplateModal?: boolean;
    togglenewTemplateModal?: () => void;
    handleNewTemplate?: (values: any) => void;
    handleSubmit?: any;
    newTemplateDetails?: any;
    handleDateChange?: (date: Date) => void;
    errors?: any;
    control?: any;
    register?: any;
}


interface Template {
    template_id: number;
    template_name: string;
    category: string;
    language: string;
    wa_approval_status: string;
    status: string;
    created_at: string;
    title?: string;
    title_text?: string;
    title_type?: string;
    title_file?: string;
    body: string;
    footer?: string;
    buttons?: any[] | null;
    header_variables?: string[];
    variables?: string[];
}
interface ButtonConfig {
    type?: string;
    text?: string;
    phoneNumber?: string;
    url?: string;
    actionType?: 'SITE' | 'CALL';
}

const user = JSON.parse(sessionStorage.getItem('shreyu_user') || '{}')?.user?.id;

const ViewTemplate: React.FC<ViewTemplateProps> = ({ templateId }) => {
    const [templates, setTemplates] = useState<Template[]>([]);
    const [headerType, setHeaderType] = useState<string>('None');
    const [headerText, setHeaderText] = useState<string>('');
    const [headerFile, setHeaderFile] = useState<File | null>(null);
    const [bodyText, setBodyText] = useState<string>('');
    const [footerText, setFooterText] = useState<string>('');
    const [variables, setVariables] = useState<string[]>([]);
    const [headervariables, setheaderVariables] = useState<string[]>([]);
    const [variableValues, setVariableValues] = useState<{ [key: string]: string }>({});
    const [headervariableValues, setheaderVariableValues] = useState<{ [key: string]: string }>({});
    const [buttons, setButtons] = useState<ButtonConfig[]>([]);
    const [newButtonText, setNewButtonText] = useState<string>('');
    const [newButtonType, setNewButtonType] = useState<'none' | 'call_to_action' | 'quick_reply'>('none');
    const [call_action_type, setCall_action_type] = useState<'SITE' | 'CALL'>('SITE');
    const [newButtonPhone, setNewButtonPhone] = useState<string>('');
    const [newButtonUrl, setNewButtonUrl] = useState<string>('');
    const [templateName, setTemplateName] = useState<string>('');
    const [language, setLanguage] = useState<string>('en_US');
    const [category, setCategory] = useState<'MARKETING' | 'UTILITY' | 'AUTHENTICATION'>('MARKETING');
    const [activeFormat, setActiveFormat] = useState<string | null>(null);
    const [companyName, setCompanyName] = useState<string>('Loading...');
    const [profile, setprofile] = useState<string>('Loading...');

    useEffect(() => {
        const fetchCompany = async () => {
            try {
                const company_id = JSON.parse(sessionStorage.getItem('shreyu_user') || '{}')?.user?.company_id;

                const response = await getCompany(company_id);
                setCompanyName(response.data.company_name || 'Company Name');
                setprofile(response.data.logo || 'logo');

            } catch (err) {
                console.error('Failed to fetch company:', err);
                setCompanyName('Company Name');
            }
        };

        fetchCompany();
    }, []);

    useEffect(() => {
        const loadTemplate = async () => {
            try {
                const response = await ViewTemplates(templateId);

                // const template = response.data;  // single template object
                // if (!template) return;

                const template = response.data.templates
                    ? response.data.templates[0]
                    : response.data;

                setBodyText(template.body || "");

                // Basic fields
                setTemplateName(template.template_name || "");
                setLanguage(template.language || "en_US");
                setCategory(template.category || "MARKETING");

                /** ---------------------------
                 *  HEADER SECTION (READ ONLY)
                 *  -------------------------- */
                setHeaderType(template.title_type || "none");
                setHeaderText(template.title_text || "");

                // If header file exists (document / image)
                if (template.title_file) {
                    setHeaderFile(template.title_file);
                }

                // Header variables
                const hVars = (template.title_text || "").match(/\{\{\d+\}\}/g) || [];
                setheaderVariables(hVars);
                setheaderVariableValues(
                    Object.fromEntries(
                        hVars.map((v: string) => [
                            v,
                            template[`variable${v.replace(/\D/g, "")}`] || ""
                        ])
                    )
                );


                /** ---------------------------
                 *  BODY SECTION (READ ONLY)
                 *  -------------------------- */
                setBodyText(template.body || "");

                // Body variables
                const bVars = (template.body || "").match(/\{\{\d+\}\}/g) || [];
                setVariables(bVars);
                setVariableValues(
                    Object.fromEntries(bVars.map((v: any) => [v, template[`variable${v.replace(/\D/g, "")}`] || ""]))
                );

                /** ---------------------------
                 *  FOOTER
                 *  -------------------------- */
                setFooterText(template.footer || "");

                /** ---------------------------
                 *  BUTTONS
                 *  -------------------------- */
                setButtons(
                    (template.buttons || []).map((btn: any) => ({
                        type: btn.type,
                        text: btn.text,
                        phoneNumber: btn.call_phone_no || null,
                        url: btn.visit_website_url || null,
                        actionType: template.call_to_action_type || "none"
                    }))
                );

            } catch (err) {
                console.error("Template Load Failed:", err);
            }
        };

        loadTemplate();
    }, [templateId]);



    const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;
        setBodyText(text);

        const vars = Array.from(new Set(text.match(/\{\{\d+\}\}/g) || []));
        setVariables(vars.slice(0, 10));

        const newValues = { ...variableValues };
        vars.forEach(v => {
            if (!newValues[v]) {
                newValues[v] = '';
            }
        });
        setVariableValues(newValues);
    };
    const handleheadChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;
        setHeaderText(text);

        const vars = Array.from(new Set(text.match(/\{\{\d+\}\}/g) || []));
        setheaderVariables(vars.slice(0, 1));

        const newValues = { ...headervariableValues };
        vars.forEach(v => {
            if (!newValues[v]) {
                newValues[v] = '';
            }
        });
        setheaderVariableValues(newValues);
    };

    const handleVariableChange = (variable: string, value: string) => {
        setVariableValues({
            ...variableValues,
            [variable]: value
        });
    };
    const handleheaderVariableChange = (variable: string, value: string) => {
        setheaderVariableValues({
            ...headervariableValues,
            [variable]: value
        });
    };

    const handleHeaderFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setHeaderFile(e.target.files[0]);
        }
    };

    const addButton = () => {
        if (newButtonText.trim()) {
            // Check button limits
            const callToActionCount = buttons.filter(b => b.type === 'call_to_action').length;
            const siteButtonCount = buttons.filter(b => b.actionType === 'SITE').length;
            const callButtonCount = buttons.filter(b => b.actionType === 'CALL').length;

            if (newButtonType === 'call_to_action') {
                if (callToActionCount >= 2) {
                    alert('Maximum 2 call to action buttons allowed');
                    return;
                }
                if (call_action_type === 'SITE' && siteButtonCount >= 1) {
                    alert('Maximum 1 website URL button allowed');
                    return;
                }
                if (call_action_type === 'CALL' && callButtonCount >= 1) {
                    alert('Maximum 1 phone number button allowed');
                    return;
                }
            }

            let newButton: ButtonConfig = {
                type: newButtonType,
                text: newButtonText,
                actionType: newButtonType === 'call_to_action' ? call_action_type : undefined
            };

            if (newButtonType === 'call_to_action') {
                if (call_action_type === 'CALL' && newButtonPhone) {
                    newButton.phoneNumber = newButtonPhone;
                } else if (call_action_type === 'SITE' && newButtonUrl) {
                    newButton.url = newButtonUrl;
                }
            }

            setButtons([...buttons, newButton]);
            setNewButtonText('');
            setNewButtonPhone('');
            setNewButtonUrl('');
        }
    };

    const removeButton = (index: number) => {
        setButtons(buttons.filter((_, i) => i !== index));
    };

    const renderPreviewText = (text: string) => {
        if (!text) return '';
        let result = text;

        variables.forEach(v => {
            const regex = new RegExp(escapeRegExp(v), 'g');
            result = result.replace(regex, variableValues[v] || v);
        });

        result = result
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
            .replace(/_(.*?)_/g, '<em>$1</em>')
            .replace(/~(.*?)~/g, '<span style="text-decoration: line-through">$1</span>')
            .replace(/\n/g, '<br/>');

        return result;
    };
    const renderHeaderPreviewText = (text: string) => {
        if (!text) return '';
        let result = text;

        headervariables.forEach(v => {
            const regex = new RegExp(escapeRegExp(v), 'g');
            result = result.replace(regex, headervariableValues[v] || v);
        });

        result = result
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
            .replace(/_(.*?)_/g, '<em>$1</em>')
            .replace(/~(.*?)~/g, '<span style="text-decoration: line-through">$1</span>')
            .replace(/\n/g, '<br/>');

        return result;
    };

    const escapeRegExp = (string: string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const renderButtonPreview = (button: ButtonConfig, index: number) => {
        // if (button.type === 'call_to_action') {
        return (
            <div key={index} className="whatsapp-call-to-action">

                {button.text ? (
                    <a href={`tel:${button.phoneNumber}`} className="whatsapp-call-button">
                        {button.text}
                    </a>
                ) : button.text ? (
                    <a href={button.url} target="_blank" rel="noopener noreferrer" className="whatsapp-url-button" >
                        {button.text}
                    </a>
                ) : null}
            </div>
        );
        // } else if (button.type === 'quick_reply') {
        //     return (
        //         <div key={index} className="whatsapp-quick-reply">
        //             <a className="whatsapp-quick-reply">
        //                 {button.text}
        //             </a>
        //         </div>
        //     );
        // }
        // return null;
    };



    const applyFormatting = (format: string) => {
        const textarea = document.getElementById('bodyText') as HTMLTextAreaElement;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = bodyText.substring(start, end);
        let newText = bodyText;
        const varNum = variables.length + 1;
        const newVar = `{{${varNum}}}`;

        switch (format) {
            case 'bold':
                newText = bodyText.substring(0, start) + `*${selectedText}*` + bodyText.substring(end);
                break;
            case 'italic':
                newText = bodyText.substring(0, start) + `_${selectedText}_` + bodyText.substring(end);
                break;
            case 'strikethrough':
                newText = bodyText.substring(0, start) + `~${selectedText}~` + bodyText.substring(end);
                break;
            case 'variable':
                const varNum = variables.length + 1;
                const newVar = `{{${varNum}}}`;
                newText = bodyText.substring(0, start) + newVar + bodyText.substring(end);
                setVariables([...variables, newVar]);
                break;
            default:
                break;
        }

        setBodyText(newText);
        setActiveFormat(format);
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(
                format === 'variable' ? start + newVar.length :
                    start + (selectedText ? 1 : 0),
                format === 'variable' ? start + newVar.length :
                    end + (selectedText ? 1 : 0)
            );
        }, 0);
    };


    return (
        <Row >
            <Col md={7} >
                <Card>
                    <Card.Header className="bg-secondary d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 text-white">WhatsApp Template</h5>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Template Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="hello_world"
                                        value={templateName}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTemplateName(e.target.value)}
                                        className="whatsapp-input"
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Language</Form.Label>
                                    <Form.Select
                                        className="whatsapp-input"
                                        value={language}  // selected value shows correctly
                                        style={{
                                            pointerEvents: "none",   // makes it readonly
                                            backgroundColor: "#e9ecef"
                                        }}
                                    >
                                        <option value="en_US">English (US)</option>
                                        <option value="en_GB">English (UK)</option>
                                        <option value="es_ES">Spanish</option>
                                        <option value="fr_FR">French</option>
                                        <option value="de_DE">German</option>
                                    </Form.Select>

                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Category</Form.Label>
                                    <Form.Select
                                        className="whatsapp-input"
                                        value={category}
                                        style={{
                                            pointerEvents: "none",   // makes it readonly
                                            backgroundColor: "#e9ecef"
                                        }}>
                                        <option value="MARKETING">Marketing</option>
                                        <option value="UTILITY">Utility</option>
                                        <option value="AUTHENTICATION">Authentication</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Header Type</Form.Label>
                                    <Form.Select
                                        className="whatsapp-input"
                                        value={headerType}
                                        style={{
                                            pointerEvents: "none",   // makes it readonly
                                            backgroundColor: "#e9ecef"
                                        }}
                                    >
                                        <option value="None">None</option>
                                        <option value="text">Text</option>
                                        <option value="image">Image</option>
                                        <option value="video">Video</option>
                                        <option value="document">Document</option>
                                        {/* <option value="location">Location</option> */}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>


                        {headervariables.length > 0 && (
                            <Row className="mb-3">
                                <Col md={8}>
                                    <Form.Group>
                                        <Form.Label>Variable Values (for preview)</Form.Label>
                                        {headervariables.map((variable, index) => (
                                            <InputGroup key={index} className="mb-2">
                                                <InputGroup.Text>{variable}</InputGroup.Text>
                                                {/* <Form.Control
                                                    type="text"
                                                    value={headervariableValues[variable] || ''}
                                                    onChange={(e) => handleheaderVariableChange(variable, e.target.value)}
                                                    placeholder={`Enter value for ${variable}`}
                                                    readOnly
                                                /> */}
                                            </InputGroup>

                                        ))}
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Body</Form.Label>

                                    <Form.Control
                                        as="textarea"
                                        id="bodyText"
                                        rows={6}
                                        className="whatsapp-input whatsapp-body"
                                        value={bodyText}
                                        onChange={handleBodyChange}
                                        placeholder="Enter your message text. Use {{1}} for variables."
                                        style={{
                                            pointerEvents: "none",   // makes it readonly
                                            // backgroundColor: "#e9ecef"
                                        }}
                                    />


                                </Form.Group>
                            </Col>
                        </Row>

                        {variables.length > 0 && (
                            <Row className="mb-3">
                                <Col md={8}>
                                    <Form.Group>
                                        <Form.Label>Variable Values (for preview)</Form.Label>
                                        {variables.map((variable, index) => (
                                            <InputGroup key={index} className="mb-2">
                                                <InputGroup.Text>{variable}</InputGroup.Text>
                                                <Form.Control
                                                    type="text"
                                                    value={variableValues[variable] || ''}
                                                    onChange={(e) => handleVariableChange(variable, e.target.value)}
                                                    placeholder={`Enter value for ${variable}`}
                                                />
                                            </InputGroup>
                                        ))}
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Footer (optional)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="whatsapp-input"
                                        placeholder="Enter footer text"
                                        value={footerText}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFooterText(e.target.value)}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    {buttons.length > 0 && (
                                        <Form.Label>Buttons</Form.Label>
                                    )}
                                    {buttons.map((btn, index) => (
                                        <div key={index} className="mb-3 p-2 border rounded">
                                            <InputGroup className="mb-2">
                                                <Form.Control
                                                    type="text"
                                                    value={btn.text || ''}
                                                    readOnly
                                                    className="whatsapp-input"
                                                />

                                            </InputGroup>
                                            <div className="small text-muted">
                                                {/* {console.log(btn.type)} */}
                                                Type: {btn.type === 'call_to_action' ? 'Call to Action' : 'Quick Reply'}
                                                {btn.type === 'call_to_action' && (
                                                    <>
                                                        {btn.phoneNumber && ` | Phone: ${btn.phoneNumber}`}
                                                        {btn.url && ` | URL: ${btn.url}`}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}

                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={5} className="border-2">
                <Card>
                    <Card.Header className="bg-secondary d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 text-white">Template Preview</h5>
                    </Card.Header>
                    <Card.Body>
                        {/* Preview Section */}
                        <div className="mt-2">
                            {/* <h5 className="mb-3">Template Preview</h5> */}
                            <div className="whatsapp-preview-container">
                                <div className="whatsapp-preview">
                                    <div className="whatsapp-header-preview">
                                        <div className="whatsapp-profile-pic">
                                            <img src={`https://api.skynyx.ai/storage/app/public/${profile}`} className="me-2 rounded-circle" height="48" alt="" />
                                        </div>
                                        <div className="whatsapp-contact">
                                            <div className="whatsapp-contact-name">{companyName}</div>
                                            <div className="whatsapp-contact-status">online</div>
                                        </div>
                                        <div className="whatsapp-menu">
                                            <i className="fas fa-ellipsis-v"></i>
                                        </div>
                                    </div>
                                    <div className="whatsapp-message-preview">
                                        {/* {console.log(headerType)} */}
                                        {headerType !== 'None' && (
                                            <div className="whatsapp-template-header">
                                                {headerType === 'text' ? (
                                                    // <div className="whatsapp-text-header">{renderHeaderPreviewText(headerText) || 'Header text will appear here'}</div>
                                                    <div className="whatsapp-text-header" dangerouslySetInnerHTML={{ __html: renderHeaderPreviewText(headerText) }} />
                                                ) : headerType === 'image' ? (
                                                    <div className="whatsapp-image-placeholder">
                                                        {headerFile ? (
                                                            <img
                                                                src={`https://api.skynyx.ai/file_storage/template/${headerFile}`}
                                                                alt=""
                                                                style={{ width: "100%", height: "100%", borderRadius: "6px" }}
                                                            />
                                                        ) : (
                                                            <div className="whatsapp-image-placeholder">[Image Preview]</div>
                                                        )}
                                                    </div>

                                                ) : headerType === 'video' ? (
                                                    <div className="whatsapp-video-header">
                                                        {headerFile ? (
                                                            <video controls>
                                                                <source src={URL.createObjectURL(headerFile)} />
                                                            </video>
                                                        ) : (
                                                            <div className="whatsapp-video-placeholder">[Video Preview]</div>
                                                        )}
                                                    </div>
                                                ) : headerType === 'document' ? (
                                                    <div className="whatsapp-document-header">
                                                        {headerFile ? (
                                                            <div>
                                                                <small className="text-muted">Document File</small>
                                                                <a
                                                                    href={`https://api.skynyx.ai/file_storage/template/${headerFile}`}
                                                                    download
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-decoration-none small d-block mt-1"
                                                                >
                                                                    Download
                                                                </a>
                                                            </div>

                                                        ) : (
                                                            <div className="whatsapp-document-placeholder">[Document Preview]</div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        )}
                                        <div className="whatsapp-template-body">
                                            {bodyText ? (
                                                <div dangerouslySetInnerHTML={{ __html: renderPreviewText(bodyText) }} />
                                            ) : (
                                                'Body text will appear here'
                                            )}
                                        </div>
                                        {footerText && (
                                            <div className="whatsapp-template-footer">
                                                {footerText}
                                            </div>
                                        )}
                                        {/* {console.log(buttons)} */}
                                        {buttons.length > 0 && (
                                            <div className="whatsapp-template-buttons">
                                                {buttons.map((button, index) => renderButtonPreview(button, index))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default ViewTemplate;